export const DEFAULT_SMS_TIMER = 60 // seconds;
export const TIME_STEP = 1000 // ms